/*
Sohel  12/19/2022 3075154998 Added Data Manager Basic Info Screen and validation.
Sohel  12/19/2022 3075154998 label Changes.
Sohel 12/23/2022 3075154998 Integrated Basic Info API.
Lalitha 12/26/2022 3075154998 Integrated get API on DM code.
Sohel 01/04/2023 3075154998 disabled Fields.
dilip 01/04/2023 3075154998 disabled Fields.
Sohel 01/09/2023 3075154998 show Disable stepper value
Sohel 01/09/2023 3075154998 fixed Type issue.
Sohel 01/09/2023 3075154998 fixed page break issue.
dilip 01/10/2023 3075154998 Added unsaved popup.
Sohel 01/12/2023 3075154998 fixed page break issue.
dilip 01/12/2023 3075154998 Fixed message and status reset issue.
Sohel 01/18/2023 3075154998 Added Multi Record Format validation.
 dilip 01/20/2023 3075154998 Added Last Step functionality
Sohel 01/20/2023 3075154998 changed Dropdown Values
Ashraf 01/27/2023 3075154998 added new fields
Ashraf 01/31/2023 3075154998 fixed useEffect issue
Ashraf 01/31/2023 3075154998 fixed active step issue
Ravi 01/31/2023 3075154998 fixed unsaved popup issue
Sohel 01/02/2023 3075154998 fixed code uppercase issue
Sohel 01/02/2023 3075154998 fixed validation issue
Ashraf 02/03/2023 3075154998 fixed draft issue
sai krisha 02/13/2023 3075154998 added client code multislected checkbox filed and
Guru Prasad 02/13/2023 3075154998 fixed scroll issues in autocomplete
suresh peddavoora 02/22/2023 3075154998 New UI changes implemented
suresh peddavoora 02/27/2023 3075154998 New UI changes
Rohini 03/01/2023 3075154998 worked on the code enhancements.
sohel 03/06/2023 3075154998 Added validation message for existing value
Raghu 03/20/2023 3075154998 fixed input field in responsive
Prakash 03/21/2023 3075154998 Fixed alignments issue.
Akhila 04/19/2023 3075154998 client code dropDown Data fix
 Ravi 04/20/2023 3075154998 implement dynamic field name
 Ravi 04/24/2023 3075154998 Added popup in dynamic field name
 Prakash 24/04/2023 3075154998 fixed alignment issue for input filed
Sohel 04/26/2023 2692790263 Fixed Created FOr Validation Issue
 Ravi 04/27/2023 3075154998 show  dynamic field name conditionally
 Akhila 05/16/2023 3075154998 comment out disable for created for
 Ravi 05/23/2023 3075154998 Added Export Format file Field
Akhila 06/12/2023 3075154998 added role access
Sohel 06/19/2023 3075154998 Enable Save Button
Akhila 06/23/2023 3075154998 report folder path added
Suresh Peddavoora 06/23/2023 3075154998 Fixed report folder path alignments
Ravi 06/23/2023 3075154998 fixed submit issue
Ravi 06/15/2023 3075154998 removed by default initial value folder path and output file name
Akhila 30/06/2023 3075154998 condtionaly label name change for folder path and file name
*/
import React, {useContext, useEffect, useRef, useState} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {
  TextField,
  FormHelperText,
  Button,
  MenuItem,
} from '@material-ui/core';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import {useSelector, useDispatch} from 'react-redux';
import {getAllReportCreatedForData} from '../../../redux/reducers/ReportMaster';
import PageLoader from '../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {
  postBasicInfo,
  fetchBasicInfoData,
  resetMsgAndStatus,
  getExportFormatType,
} from '../../../redux/reducers/EDI/index';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {upperCaseCode} from '../../../components/UpperCaseCode';
import {NumberFormatter} from '../../../components/UserDefinedForm/AppTextInputComponents';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';

const promptOptions = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'No'},
];
const DMBasicInfo = ({activeStep, handleNext, handleDirty, editExisting, setActiveStep}) => {
  const {reusableInputStyles} = useContext(ThemeContext);

  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const codeRef = useRef();
  const {
    isBasicInfoLoading,
    basicInfoErrorMsg,
    basicInfoSuccessMsg,
    addBasicInfoStatus,
    dmCode,
    basicInfoData,
    allDataManagerCode,
    allExportCode,
  } = useSelector(({ediExport}) => ediExport);
  const [codePopover, setCodePopover] = useState(false);
  const [DMCodesData, setDMCodesData] = useState();
  const saveRef = useRef();
  const checkNumberExist = (value) => {
    if (allExportCode && allExportCode?.length > 0 && value) {
      const ar = [];
      allExportCode.filter((i) => {
        if (
          i?.interchangeControlNumber?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkNumberAlreadyExist = (value) => {
    if (allExportCode && allExportCode?.length > 0 && value) {
      const ar = [];
      allExportCode.filter((i) => {
        if (
          i?.interchangeControlNumber?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);

  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (
          item.value === option ||
          item.key === option ||
          item.userName === option ||
          item.categoryCode === option
        ) {
          label = item;
        }
      });
    return label;
  };
  const initialVal = {
    code: basicInfoData?.exportCode ? basicInfoData?.exportCode : '',
    description: basicInfoData?.exportDescription ? basicInfoData?.exportDescription : '',
    interchangeControlNumber: basicInfoData?.interchangeControlNumber ?
      basicInfoData?.interchangeControlNumber :
      '',
    hospitalName: basicInfoData?.hospitalName ? basicInfoData?.hospitalName : '',
    providerName: basicInfoData?.providerName ? basicInfoData?.providerName : '',
    hospitalCity: basicInfoData?.hospitalCity ? basicInfoData?.hospitalCity : '',
    hospitalState: basicInfoData?.hospitalState ? basicInfoData?.hospitalState : '',
    hospitalZip: basicInfoData?.hospitalZip ? basicInfoData?.hospitalZip : '',
    infoReceiverId: basicInfoData?.infoReceiverId ? basicInfoData?.infoReceiverId : '',
    clientPrompt: basicInfoData?.clientPrompt ?
      getObject(basicInfoData?.clientPrompt, promptOptions) :
      {key: 'N', value: 'No'},
    auditDatePrompt: basicInfoData?.auditPrompt ?
      getObject(basicInfoData?.auditPrompt, promptOptions) :
      {key: 'N', value: 'No'},
  };

  const validationSchema = Yup.object().shape({
    description: Yup.string()
      .test('description', 'Export Description is required', (value) => {
        return value?.replaceAll(' ', '');
      })
      .required('Description is required'),
    code: basicInfoData?.exportCode ? null : Yup.string().required(`Export Code is required`),
    interchangeControlNumber: Yup.string()
      .test('interchangeControlNumber', 'Interchange Control Number is required', (value) => {
        return value?.replaceAll(' ', '');
      })
      .required('Interchange Control Number is required')
      .test('code', 'Interchange Control Number already exist', (value) =>
        basicInfoData?.interchangeControlNumber?.toString() !== value?.toString() ?
          !checkNumberExist(value) :
          true,
      )
      .test('code', `Interchange Control Number has already been used in the past`, (value) =>
        basicInfoData?.interchangeControlNumber?.toString() !== value?.toString() ?
          !checkNumberAlreadyExist(value) :
          true,
      ),
    clientPrompt: Yup.mixed().test('clientPrompt', 'Client Prompt is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    auditDatePrompt: Yup.mixed().test(
      'auditDatePrompt',
      'Audit Date Prompt is required',
      (value) => {
        if (!value?.value) {
          return false;
        } else {
          return true;
        }
      },
    ),
  });
  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const payload = {
      edi270ExportId: basicInfoData?.edi270ExportId ? basicInfoData?.edi270ExportId : 0,
      exportCode: values?.code ? values?.code : '',
      exportDescription: values?.description ? values?.description : '',
      interchangeControlNumber: values?.interchangeControlNumber ?
        values?.interchangeControlNumber :
        '',
      hospitalName: values?.hospitalName ? values?.hospitalName : '',
      providerName: values?.providerName ? values?.providerName : '',
      hospitalCity: values?.hospitalCity ? values?.hospitalCity : '',
      hospitalState: values?.hospitalState ? values?.hospitalState : '',
      hospitalZip: values?.hospitalZip ? values?.hospitalZip : '',
      infoReceiverId: values?.infoReceiverId ? values?.infoReceiverId : '',
      auditPrompt: values?.auditDatePrompt?.key ? values?.auditDatePrompt?.key : '',
      clientPrompt: values?.clientPrompt?.key ? values?.clientPrompt?.key : '',
      senderId: basicInfoData?.senderId ? basicInfoData?.senderId : '',
      receiverId: basicInfoData?.receiverId ? basicInfoData?.receiverId : '',
      custReference: basicInfoData?.custReference ? basicInfoData?.custReference : '',
      origCompany: basicInfoData?.origCompany ? basicInfoData?.origCompany : '',
      custLastName: basicInfoData?.custLastName ? basicInfoData?.custLastName : '',
      custFirstName: basicInfoData?.custFirstName ? basicInfoData?.custFirstName : '',
      custIdentifier: basicInfoData?.custIdentifier ? basicInfoData?.custIdentifier : '',
      custAddress: basicInfoData?.custAddress ? basicInfoData?.custAddress : '',
      custCity: basicInfoData?.custCity ? basicInfoData?.custCity : '',
      custState: basicInfoData?.custState ? basicInfoData?.custState : '',
      custZip: basicInfoData?.custZip ? basicInfoData?.custZip : '',
      custBirthDate: basicInfoData?.custBirthDate ? basicInfoData?.custBirthDate : null,
    };
    dispatch(postBasicInfo(payload));
  };

  useEffect(() => {
    dispatch(getAllReportCreatedForData());
    dispatch(getExportFormatType());
  }, []);

  useEffect(() => dispatch(resetMsgAndStatus()), []);

  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        if (addBasicInfoStatus === 200 && basicInfoSuccessMsg && !saveRef.current) {
          setTimeout(() => {
            handleNext('0');
          }, 1000);
        }
        dispatch(resetMsgAndStatus());
      }, 1500);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg]);

  useEffect(() => {
    if (dmCode) {
      dispatch(fetchBasicInfoData({code: dmCode}));
    }
  }, [dmCode]);

  window.onclick = function() {
    setCodePopover(false);
  };

  const getRecordCodesData = () => {
    if (allDataManagerCode && allDataManagerCode?.length > 0) {
      return allDataManagerCode?.filter((i) => String(i.dmCode)?.startsWith(DMCodesData));
    } else {
      return [];
    }
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
        validateOnBlur
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row global-field-textfields new-standard-textfields mt-2">
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Export Code`}
                    label={`Export Code`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="code"
                    required
                    value={values?.code}
                    disabled={Boolean(basicInfoData?.exportCode)}
                    inputRef={codeRef}
                    onChange={(e) => {
                      const value = upperCaseCode(codeRef);
                      setFieldValue('code', value);
                      if (e.target.value) {
                        setCodePopover(true);
                        setDMCodesData(e.target.value);
                      } else if (e.target.value === '') {
                        setCodePopover(false);
                      }
                    }}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.code}
                    error={Boolean(touched.code && errors.code)}
                  />
                  <FormHelperText>{touched.code && errors?.code && errors.code}</FormHelperText>
                  <div className="windowcode-popover Add-trigger-group-popover">
                    {codePopover &&
                      getRecordCodesData()?.map((data, i) => (
                        <MenuItem fullWidth key={i}>
                          {data?.dmCode}
                        </MenuItem>
                      ))}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Export Description`}
                    label={`Export Description`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="description"
                    required
                    value={values.description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.description}
                    error={Boolean(touched.description && errors.description)}
                  />
                  <FormHelperText>
                    {touched.description && errors?.description && errors.description}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Interchange Control Number `}
                    label={`Interchange Control Number`}
                    name="interchangeControlNumber"
                    // disabled={Boolean(basicInfoData?.interchangeControlNumber)}
                    InputProps={{
                      inputComponent: NumberFormatter,
                    }}
                    value={values.interchangeControlNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.interchangeControlNumber}
                    error={Boolean(
                      touched.interchangeControlNumber && errors.interchangeControlNumber,
                    )}
                  />
                  <FormHelperText>
                    {touched.interchangeControlNumber &&
                      errors?.interchangeControlNumber &&
                      errors.interchangeControlNumber}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Provider Name`}
                    label={`Provider Name`}
                    name="providerName"
                    value={values.providerName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.providerName}
                    error={Boolean(touched.providerName && errors.providerName)}
                  />
                  <FormHelperText>
                    {touched.providerName && errors?.providerName && errors.providerName}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Hospital Name`}
                    label={`Hospital Name`}
                    name="hospitalName"
                    value={values.hospitalName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.hospitalName}
                    error={Boolean(touched.hospitalName && errors.hospitalName)}
                  />
                  <FormHelperText>
                    {touched.hospitalName && errors?.hospitalName && errors.hospitalName}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Info Receiver Id`}
                    label={`Info Receiver Id`}
                    name="infoReceiverId"
                    value={values.infoReceiverId}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.infoReceiverId}
                    error={Boolean(touched.infoReceiverId && errors.infoReceiverId)}
                  />
                  <FormHelperText>
                    {touched.infoReceiverId && errors?.infoReceiverId && errors.infoReceiverId}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Hospital City`}
                    label={`Hospital City`}
                    name="hospitalCity"
                    value={values.hospitalCity}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.hospitalCity}
                    error={Boolean(touched.hospitalCity && errors.hospitalCity)}
                  />
                  <FormHelperText>
                    {touched.hospitalCity && errors?.hospitalCity && errors.hospitalCity}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Hospital State`}
                    label={`Hospital State`}
                    name="hospitalState"
                    value={values.hospitalState}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.hospitalState}
                    error={Boolean(touched.hospitalState && errors.hospitalState)}
                  />
                  <FormHelperText>
                    {touched.hospitalState && errors?.hospitalState && errors.hospitalState}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Hospital Zip`}
                    label={`Hospital Zip`}
                    name="hospitalZip"
                    InputProps={{
                      inputComponent: NumberFormatter,
                    }}
                    value={values.hospitalZip}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.hospitalZip}
                    error={Boolean(touched.hospitalZip && errors.hospitalZip)}
                  />
                  <FormHelperText>
                    {touched.hospitalZip && errors?.hospitalZip && errors.hospitalZip}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    name="clientPrompt"
                    id="clientPrompt"
                    size="small"
                    options={promptOptions}
                    required
                    value={values.clientPrompt}
                    getOptionLabel={(option) => {
                      return option && option.value;
                    }}
                    onChange={(e, value) => {
                      setFieldValue('clientPrompt', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName}`}
                          variant="outlined"
                          margin="dense"
                          // InputLabelProps={{ shrink: true }}
                          label="Client Id Prompt"
                          placeholder="Select Client Id Prompt"
                          required
                          error={touched.clientPrompt && errors.clientPrompt}
                        />
                      </div>
                    )}
                  />
                  <FormHelperText>
                    {touched.clientPrompt && errors.clientPrompt && errors.clientPrompt}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    name="auditDatePrompt"
                    id="auditDatePrompt"
                    size="small"
                    options={promptOptions}
                    required
                    value={values.auditDatePrompt}
                    getOptionLabel={(option) => {
                      return option && option.value;
                    }}
                    onChange={(e, value) => {
                      setFieldValue('auditDatePrompt', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName}`}
                          variant="outlined"
                          margin="dense"
                          // InputLabelProps={{ shrink: true }}
                          label="Audit Date Prompt"
                          placeholder="Select Audit Date Prompt"
                          required
                          error={touched.auditDatePrompt && errors.auditDatePrompt}
                        />
                      </div>
                    )}
                  />
                  <FormHelperText>
                    {touched.auditDatePrompt && errors.auditDatePrompt && errors.auditDatePrompt}
                  </FormHelperText>
                </div>
              </div>

              <div className="d-flex justify-content-center align-items-center new-standard-textfields disabled-button">
                <Button
                  variant="outlined"
                  disabled={activeStep === 0}
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                >
                  Back
                </Button>
                {/* {basicInfoData?.isDraft === "N" && ( */}
                <Button
                  variant="outlined"
                  type="button"
                  className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                  onClick={() => {
                    saveRef.current = true;
                    handleDirty(false, 'fixed');
                    handleSubmit(values);
                    // setActiveStep(activeStep + 1);
                  }}
                >
                  Save
                </Button>
                {/* )} */}
                <Button
                  variant="outlined"
                  type="submit"
                  className={`search-btn ml-1 ${classes.buttonRoot}`}
                  onClick={() => {
                    saveRef.current = false;
                  }}
                >
                  Save & Next
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
      {isBasicInfoLoading && <PageLoader />}
      {basicInfoErrorMsg && <ErrorSnackbar errorMsg={basicInfoErrorMsg} />}
      {basicInfoSuccessMsg && <SuccessSnackbar successMsg={basicInfoSuccessMsg} />}
    </>
  );
};

export default DMBasicInfo;
